import { render } from "./SendModal.vue?vue&type=template&id=bffe6688&ts=true"
import script from "./SendModal.vue?vue&type=script&lang=ts"
export * from "./SendModal.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\src\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__